// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const ReturnFulfillmentStatus = {
  NoItemsToReturn: {
    Name: 'No Items To Return',
    Value: 'no_items_to_return',
    Description: 'No items will be returned',
    Icon: 'CircleSlash',
    Variant: 'outline',
  },
  PickupPending: {
    Name: 'Pickup Pending',
    Value: 'pickup_pending',
    Description: 'Employee will pick up items',
    Icon: 'MapPinPlusInside',
    Variant: 'warning',
  },
  DropOffPending: {
    Name: 'Drop Off Pending',
    Value: 'drop_off_pending',
    Description: 'Customer will drop off items',
    Icon: 'MapPin',
    Variant: 'warning',
  },
  ShipmentPending: {
    Name: 'Shipment Pending',
    Value: 'shipment_pending',
    Description: 'Customer will ship items',
    Icon: 'PackagePlus',
    Variant: 'warning',
  },
  ReturnShipped: {
    Name: 'Return Shipped',
    Value: 'return_shipped',
    Description: 'Customer shipped items',
    Icon: 'Package',
    Variant: 'info',
  },
  ReturnPartiallyReceived: {
    Name: 'Return Partially Received',
    Value: 'return_partially_received',
    Description: 'Return partially received',
    Icon: 'PackageOpen',
    Variant: 'info',
  },
  ReturnReceived: {
    Name: 'Return Received',
    Value: 'return_received',
    Description: 'Items received by employee',
    Icon: 'PackageCheck',
    Variant: 'success',
  },
  ReturnRestocked: {
    Name: 'Return Restocked',
    Value: 'return_restocked',
    Description: 'Items returned and restocked',
    Icon: 'FileBox',
    Variant: 'success',
  },
  ReturnDamaged: {
    Name: 'Return Damaged',
    Value: 'return_damaged',
    Description: 'Items returned damaged',
    Icon: 'PackageX',
    Variant: 'destructive',
  },
} as const

export type ReturnFulfillmentStatusValue =
  (typeof ReturnFulfillmentStatus)[keyof typeof ReturnFulfillmentStatus]['Value']
